import fetchApi from "ui-io/fetch-api";
import * as t from "io-ts";

type SigninRequestT = {
  username?: string;
  email?: string;
  password: string | false;
};

const SigninCodec = t.type({
  userId: t.string,
  email: t.string,
  name: t.string,
  username: t.string,
  roleInFirm: t.union([t.string, t.null, t.undefined]),
  accessToken: t.string,
  refreshToken: t.string,
});

export const signInUser = (signInReqObj: SigninRequestT) => {
  return fetchApi({
    service: "user-service",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    pathname: `/sign-in`,
    codec: SigninCodec,
    body: signInReqObj,
  });
};
